import React from "react";

function EmailQuoteSuccess() {
  return (
    <>
      <div className="onboarding-content-box pt-2 pb-3 mb-0 text-center border-0">
        <h2 className="mb-4">Thank you!</h2>
        <p className="onboarding-card-text mb-0">
          Your Quote has been sent. If you don’t receive an email within 15
          minutes, please Contact Us.
        </p>
      </div>
    </>
  );
}

export default EmailQuoteSuccess;
